import { env } from '../env';
import Grid from "@mui/material/Grid";
import { Typography, TextField, Button } from "@mui/material";
import ChoiceHistory from "../component/ChoiceHistory";
import SmsValidation from "../component/SmsValidation";
import { useFormik } from "formik";
import * as yup from "yup";




const validationSchema = yup.object({
  nom: yup.string().required("Vous devez entrez votre nom"),
    prenom: yup.string().required("Vous devez entrez votre prenom"),
  email: yup
      .string("Vous devez entrez votre adresse email")
    .email("L'adresse email semble invalide")
      .required("Vous devez entrez votre adresse email"),
  tel: yup
    .string()
    .min(10, "Numero incomplet")
      .required("Vous devez entrez votre numéro"),
    observations: yup
        .string().max(200,"L'observation est limitée à 200 caractères")
});

function Confirm({ page, setPage }) {
  const formik = useFormik({
    initialValues: {
      nom: "",
      prenom: "",
      email: "",
      tel: "",
      observations: "",
      page: page,
      isPatient: false
    },
    validationSchema: validationSchema,
      onSubmit: (values) => {
        
      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          LK: env.REACT_APP_LICENCE_KEY,
          ENVID: env.REACT_APP_ENV_ID,
          Lastname: formik.values.nom,
          Firstname: formik.values.prenom,
          Email: formik.values.email,
          PhoneNo: formik.values.tel,
          Observations: formik.values.observations,
          From: page.date,
          To: page.dateTo,
          PlaceID: page.place.ID,
          PractitionerID: page.praticien.ID,
          AppointmentTypeID: page.motif.ID,
          IsPatient: formik.values.isPatient
        }),
        mode: "cors",
      };
      // console.log(request);
          fetch(`${env.REACT_APP_PROXY_BASE_URL}/appointment`, request)
              .then((response) => response.json())
              .then((res) => {
                  if (res?.SmsGuid) {
                      setPage({
                          ...page,
                          smsConfirmation: true,
                          smsGuid: res?.SmsGuid,
                      });
                  } else {
                      setPage({
                          ...page,
                          smsConfirmation: false,
                      });
                  }
              })
              .catch((err) => {
                  setPage({
                      ...page,
                      smsConfirmation: false,
                  });
              }
        );
    },
  });

  return (
    <Grid container component={"form"} spacing={3}>
      {/* Modale pour la confirmation SMS */}
      <SmsValidation page={page} setPage={setPage} />
      {/* Historique des choix */}
      <ChoiceHistory page={page} setPage={setPage} />

      {/* Saisie coordonnées pour confirmation du rendez-vous */}
      <Grid item order={{ xs: 2, md: 1 }} xs={12} md={6} mt={5}>
        <Grid container justifyContent="center" direction="column" spacing={2}>
          {/* Titre */}
          <Grid item xs={12}>
            <Typography align="center" variant="h4" mb={6}>
              Laissez-nous vos coordonnées, vous recevrez un code SMS pour
              confirmer votre rendez-vous
            </Typography>
          </Grid>

          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <TextField
                              size="small" fullWidth
                variant="outlined"
                id="nom"
                label="Nom"
                value={formik.nom}
                error={formik.touched.nom && !!formik.errors.nom}
                helperText={formik.touched.nom && formik.errors.nom}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                              size="small" fullWidth
                variant="outlined"
                id="prenom"
                label="Prénom"
                value={formik.prenom}
                error={formik.touched.prenom && !!formik.errors.prenom}
                helperText={formik.touched.prenom && formik.errors.prenom}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                              size="small" fullWidth
                variant="outlined"
                id="email"
                label="Email"
                value={formik.email}
                error={formik.touched.email && !!formik.errors.email}
                helperText={formik.touched.email && formik.errors.email}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                              size="small" fullWidth
                variant="outlined"
                id="tel"
                label="Téléphone"
                value={formik.tel}
                error={formik.touched.tel && !!formik.errors.tel}
                helperText={formik.touched.tel && formik.errors.tel}
                onChange={formik.handleChange}
              />
                      </Grid>
              <Grid item>
                          <Typography variant="body1" my={1}>
                              Déjà patient ? <input type="checkbox" id="isPatient" />
                          </Typography>
                      </Grid>
                      <Grid item>
                          <TextField
                              size="small" fullWidth
                              variant="outlined"
                              id="observations"
                              label="Observations"
                              value={formik.observations}
                              onChange={formik.handleChange}
                              multiline
                              error={formik.touched.observations && !!formik.errors.observations}
                              helperText={formik.touched.observations && formik.errors.observations}
                              rows={4}
                              maxrows={4}
                              inputProps={{ maxLength: 200 }}
                          />
                      </Grid>
            <Grid item my={1} mb={3}>
              <Button
                variant="contained"
                fullWidth
                              onClick={formik.handleSubmit} 
              >
                Confirmer
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Confirm;
